export const makeBasicAuthToken = (login, password) => {
  const token = `${login}:${password}`;
  // To Base64 Encoding ->

  const hash = btoa(token);

  return 'Basic ' + hash;
};
